import { useEffect, useState } from "react"
import { UpgradePlan } from "../../pages/UpgradePlan"
import {
  Tab,
} from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import {
  DeleteRequest,
} from "../../Utils/hooks/ApiHandler"
import useLocalStorageState from "use-local-storage-state"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import DeleteModal from "../DeleteModal"
import { toast } from "sonner"
import "./salesOrders.css"
import { SalesHeader } from "./SalesModule/SalesHeader"
import { SalesListing } from "./SalesModule/SalesListing"

export const SalesOrder = () => {
  const navigate = useNavigate()

  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  })

  const customer_id = customer?.customer_details?.customer_id || 1
  const token = customer?.token?.authorization || ""
  const rf = customer?.token?.authentication || ""
  const extras = { customer, setCustomer, rf, navigate }
  const headers = {
    Authorization: token,
    Authentication: rf,
  }

  const [isMyApproval, setMyApproval] = useState(() => {
    const saved = localStorage.getItem("sale_isMyApproval");
    return saved === "true";
  });
  const [allSalesOrder, setAllSalesOrder] = useState([])
  const [departmentToDelete, setDepartmentToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [loading, setLoading] = useState(false)
  // States for using pagination
  // Calculate total pages

  const [limit, setLimit] = useState(25)
  const [allOffset, setAllOffset] = useState(0)
  const [myApprovalOffset, setMyApprovalOffset] = useState(0)

  const activeOffset = isMyApproval ? myApprovalOffset : allOffset
  const setActiveOffset = isMyApproval ? setMyApprovalOffset : setAllOffset
  const [search, setSearch] = useState("")
  const params = {
    limit,
    offset: activeOffset,
    search,
  }

  const [endpoint, setEndpoint] = useState("")
  const [queryKey, setQueryKey] = useState("")

  // states to store the filter data
  const [filterStates, setFilterState] = useState([])
  // const lastHeading = localStorage.getItem("sales_last_heading")
  const [heading, setHeading] = useState("All Sales Order")
  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null)

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([])

  // Add states for filter pagination and search
  const [filterOffset, setFilterOffset] = useState(0)

  // sales permission
  const permission = customer.customer_details?.permission
  const isSalesOrder = permission?.find(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")
  const salesPermission = permission?.filter(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")
  const user_type = Number(customer.customer_details?.user_type)
  const salesGrant = {
    isView: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "sales_order")?.delete)) : true,
    isImport: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "import")?.is_action)) : true,
    isExport: user_type !== 1 ? Boolean(Number(isSalesOrder && salesPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "export")?.is_action)) : true,
  }
  // //list of import field
  // const salesOrderImportFields = [
  //   { id: "contact_name", label: "Contact Name", required: true },
  //   { id: "order_date", label: "Sales Order Date", required: true },
  //   { id: "shipment_date", label: "Shipment Date", required: true },
  //   { id: "owner", label: "Owner", required: true },
  //   { id: "deal_name", label: "Deal", required: false },
  //   { id: "quotation_no", label: "Quotation Number", required: false },
  //   { id: "payment_term", label: "Payment Terms", required: true },
  //   { id: "description", label: "Short Description", required: true },
  //   { id: "product_services", label: "Product & Services", required: true },
  //   { id: "quantity", label: "Quantity", required: true },
  //   { id: "product_description", label: "Product Description", required: false },
  //   { id: "rate", label: "Rate", required: true },
  //   { id: "gst", label: "GST(%)", required: true },
  //   { id: "discount_type", label: "Discount Type", required: false },
  //   { id: "discount", label: "Discount", required: false },
  //   { id: "discount_amount", label: "Amount", required: true },
  //   { id: "sub_total", label: "Sub Total", required: true },
  //   { id: "grand_total", label: "Grand Total", required: true },
  //   { id: "special_discount", label: "Special Discount", required: false },
  //   { id: "special_discount_type", label: "Special Discount Type", required: false },
  //   { id: "special_discount_amount", label: "Special Discount Amount", required: false },
  //   { id: "shipping_charge", label: "Shipping Charge", required: false },
  //   { id: "gst_amount", label: "GST Amount", required: false },
  //   { id: "customer_note", label: "Customer Notes", required: false },
  //   { id: "terms_condition", label: "Terms & Conditions", required: false },
  //   { id: "billing_address", label: "Billing Address", required: false },
  //   { id: "billing_country", label: "Billing Country", required: false },
  //   { id: "billing_state", label: "Billing State", required: false },
  //   { id: "billing_city", label: "Billing City", required: false },
  //   { id: "billing_zipcode", label: "Billing Zipcode", required: false },
  //   { id: "shipping_address", label: "Shipping Address", required: false },
  //   { id: "shipping_country", label: "shipping Country", required: false },
  //   { id: "shipping_state", label: "shipping State", required: false },
  //   { id: "shipping_city", label: "shipping City", required: false },
  //   { id: "shipping_zipcode", label: "shipping Zipcode", required: false },
  // ]

  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (filterCategories?.length > 0 && !isInitialized) {
      const lastHeading = localStorage.getItem("sales_last_heading")
      const existingFilter = filterCategories.find(
        (filter) => filter.card_name === lastHeading
      )
      setHeading(existingFilter ? lastHeading : "All Sales Order")
      setIsInitialized(true)
    }
  }, [filterCategories, isInitialized])

  //  filter dropdown options
  const dropdownOptions = [
    { value: "contact_id", label: "Contact", },
    { value: "owner_id", label: "Owner", },
    { value: "company_id", label: "Company Name", },
    { value: "deal_id", label: "Deal", },
    { value: "sale_no", label: "Sales Number" },
    { value: "approve_by", label: "Approve By" },
    { value: "shipment_date", label: "Shipment Date", type: "date-range" },
    { value: "order_date", label: "Order Date", type: "date-range" },
    { value: "created_at", label: "Created at", type: "date-range" },
  ]

  useEffect(() => {
    if (tempFilterData !== null) {
      setActiveOffset(0)
    }
  }, [tempFilterData])

  useEffect(() => {
    const lowerHeading = heading
      ? heading?.toLowerCase()?.split(" ").join("_")
      : heading

    if (isMyApproval) {
      setEndpoint(
        `/sales/fetchMyApprovals/${customer_id}/${customer?.customer_details?.id}`
      )
      setQueryKey(`fetchApprovalSalesOrder`)
    } else if (lowerHeading === "all_sales_order") {
      setEndpoint(
        `/sales/fetchAllOrders/${customer_id}/${customer?.customer_details?.id}/${customer?.customer_details?.user_type}`
      )
      setQueryKey(`fetchSalesOrder`)
    } else {
      // Set for filtered category
      const matchedCategory = filterCategories.find(
        (category) => category.card_name === heading
      )
      if (matchedCategory) {
        setEndpoint(
          `/sales/fetchAllOrders/${customer_id}/${customer?.customer_details?.id}/${customer?.customer_details?.user_type}/${matchedCategory.id}`
        )
        setQueryKey(
          `filterQuery${matchedCategory.card_name
            .toLowerCase()
            ?.split(" ")
            .join("_")}`
        )
      }
    }
  }, [heading, filterCategories, isMyApproval])

  // Single useGetRequest call
  const {
    data: salesOrderData,
    error,
    refetch: fetchSalesOrder,
    isLoading,
    isError,
  } = useGetRequest(
    endpoint,
    [queryKey, isMyApproval],
    headers,
    { customer, setCustomer, rf: headers.Authentication, navigate },
    params
  )

  // storing all contacts to a state to use it in the custom dropdown for the dynamic fields
  useEffect(() => {
    if (
      salesOrderData &&
      salesOrderData.filter_data &&
      salesOrderData.filter_data[0] &&
      salesOrderData.filter_data[0].filter_values
    ) {
      const values = salesOrderData.filter_data[0].filter_values
      const parsedState = JSON.parse(values)
      const filteredArray = parsedState?.map((state) => {
        const dropdownOption = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        )
        let mappedOptions = null
        if (dropdownOption?.option && Array.isArray(dropdownOption.option)) {
          if (dropdownOption.value === "owner_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.id,
              label: opt.leadName,
            }))
          } else if (dropdownOption.value === "company_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.id,
              label: opt.company_name,
            }))
          } else if (dropdownOption.value === "contact_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.contactId,
              label: opt.contact_name,
            }))
          } else if (dropdownOption.value === "deal_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.id,
              label: opt.deal_name + " " + `(${opt.deal_no})`,
            }))
          }
        }
        return {
          id: state.label_name,
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownOption ? dropdownOption.label : state.label_name,
          option: mappedOptions,
          subFilterType: state.label_query,
          value:
            state.label_query === "between"
              ? { start: state.label_value[0], end: state.label_value[1] }
              : state.label_value,
        }
      })

      setFilterState(filteredArray)
    } else {
      setFilterState([])
    }

    setAllSalesOrder(salesOrderData?.data)
    // setTotalCount(salesOrderData?.["total_count"])
  }, [queryKey, salesOrderData, isMyApproval])

  // Confirm delete and call API
  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const item = allSalesOrder.find((d) => d.sales_id === departmentToDelete)

      const res = await DeleteRequest(
        `sales/deleteSalesOrder/${departmentToDelete}/${customer?.customer_details?.id}`,
        { headers },
        { extras }
      )

      if (res?.status === "success") {
        toast.success(res.message)
        await fetchSalesOrder()
        setLoading(false)
      } else if (res.status === "fail") {
        toast.error(res.message)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error("Delete error:", error)
    } finally {
      setLoading(false)
      setShowDeleteModal(false)
      setDepartmentToDelete(null)
    }
  }

  const columnOptions = [
    // { key: "sn", label: "#",locked: true },
    { key: "sales_order_date", label: "Date" },
    { key: "sale_no", label: "Sales Order#", mandatory: true },
    { key: "quotation_number", label: "Quotation Number" },
    { key: "contact_full_name", label: "Customer Name" },
    { key: "status", label: "Status" },
    { key: "invoiced", label: "Invoiced" },
    // { key: "confirmed", label: "Payment" },
    { key: "items", label: "Amount" },
    { key: "shipment_date", label: "Expected Shipment Date" },
    // { key: "order_status", label: "Order Status" },
    // { key: "delivery_method", label: "Delivery Method" },
  ]
  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = localStorage.getItem("visibleSalesColumns");
    const allColumnKeys = columnOptions?.map(col => col.label);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });

  useEffect(() => {
    if (endpoint && queryKey) {
      fetchSalesOrder();
    }
  }, [isMyApproval, endpoint]);
  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message="Are you sure you want to delete this item?"
      />
      <Tab.Container defaultActiveKey="tab-sales">
        <Tab.Content>
          <Tab.Pane
            className="p-0 pt-0 pb-3"
            eventKey="tab-sales"
            style={{
              border: "none",
              animation: "cardEntry 1s ease-out forwards",
            }}
          >
            <SalesHeader
              salesGrant={salesGrant}
              isMyApproval={isMyApproval}
              setMyApproval={setMyApproval}
              heading={heading}
              setHeading={setHeading}
              columns={columns}
              setColumns={setColumns}
              columnOptions={columnOptions}
              filterStates={filterStates}
              setFilterState={setFilterState}
              filterCategories={filterCategories}
              setFilterCategories={setFilterCategories}
              filterOffset={filterOffset}
              setFilterOffset={setFilterOffset}
              setTempFilterData={setTempFilterData}
              setActiveOffset={setActiveOffset}
              setSearch={setSearch}
            />
            <SalesListing
              isMyApproval={isMyApproval}
              setMyApproval={setMyApproval}
              allSalesOrder={allSalesOrder}
              activeOffset={activeOffset}
              setActiveOffset={setActiveOffset}
              salesOrderData={salesOrderData}
              fetchSalesOrder={fetchSalesOrder}
              heading={heading}
              setHeading={setHeading}
              limit={limit}
              setLimit={setLimit}
              isLoading={isLoading}
              columns={columns}
              setColumns={setColumns}
            />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container >

      {
        !isSalesOrder &&
        <UpgradePlan module_name={"Sales Order"} />
      }
    </>
  )
}